module.exports = __webpack_public_path__ + "img/cocina2.1267e0c9.svg";